import {
  ArchiveRestore,
  ArrowRight,
  Blocks,
  ChartColumn,
  ChartGantt,
  Circle,
  CircleAlert,
  Download,
  File,
  FileText,
  Folder,
  FolderKanban,
  Import,
  Inbox,
  KeyRound,
  ListFilter,
  ListTodo,
  Package,
  Pencil,
  Server,
  Settings,
  SquareCheck,
  SquareKanban,
  Star,
  SunMoon,
  Table2,
  Timer,
  Trash2,
  Users,
  Workflow,
  type LucideIcon,
} from 'lucide-react';

/**
 * The icons the mocks draw with CSS boxes, now Lucide icons chosen for the same meaning. Each
 * is imported by name so the bundle keeps only the ones listed here.
 */
export const SHAPES = {
  /** Sidebar "Roadmap": the mock's filled timeline bar. */
  roadmap: ChartGantt,
  /** Sidebar "Backlog": a ruled list. */
  backlog: ListTodo,
  /** Sidebar "Board": columns of cards. */
  board: SquareKanban,
  /** Sidebar "Sprints": a time box. */
  sprint: Timer,
  /** Sidebar "Reports": bottom-aligned bars. */
  reports: ChartColumn,
  /** A doc page. */
  doc: FileText,
  /** Docs: a page that is one HTML or PDF file, drawn full bleed. */
  'file-page': File,
  /** Docs: a folder, a page that only groups the pages under it. */
  folder: Folder,
  /** "Linked pages" and "Members": an outlined circle. */
  circle: Circle,
  /** "Releases": a shipped package. */
  releases: Package,
  /** Top bar and settings links. */
  settings: Settings,
  /** Top bar inbox: the mock's tray. */
  inbox: Inbox,
  /** Top bar theme menu: light and dark. */
  theme: SunMoon,
  /** Setup option tiles: single sign-on with any identity provider. */
  key: KeyRound,
  /** Setup option tiles: a model server on the local network. */
  server: Server,
  /** Setup option tiles: spreadsheet (CSV) exports. */
  table: Table2,
  /** Settings: switch a section from its read view to editing. */
  edit: Pencil,
  /** Backups: put a backup back in place of the live workspace. */
  restore: ArchiveRestore,
  download: Download,
  /** Import sources (Jira, Confluence): an arrow into a box, never the vendor's logo. */
  import: Import,
  /** Settings › Modules, and the Create menu's empty state. */
  modules: Blocks,
  /** Board cards: the mock's ☑ before the subtask count. */
  subtasks: SquareCheck,
  /** Workflow: the mock's → before a transition's target. */
  arrow: ArrowRight,
  /** Empty states: no project yet, no members, no saved filters, no workflows, a failed load. */
  project: FolderKanban,
  people: Users,
  filter: ListFilter,
  workflow: Workflow,
  alert: CircleAlert,
  /** Docs: star a page; the home's Starred list. */
  star: Star,
  /** Docs: move a page to the trash, and the space's trash. */
  trash: Trash2,
} satisfies Record<string, LucideIcon>;

export type ShapeName = keyof typeof SHAPES;
